import React from 'react'
import styled from '@emotion/styled'
import { isAllUpSelection } from '@mobi/betslip/helpers/typeGuards'
import { AllUpSelection } from '@mobi/betslip/types'
import { Accordion } from '@mobi/component-library/Base/Accordion'
import { hexColors } from '@mobi/settings/hexColors'
import { state$ as quickbetState$ } from '@core/Areas/Quickbet/driver'
import { observeImmutable } from '@core/Components/HOCs'
import { ToggleAllUpFormula } from '../../signals'

type Props = {
  betPlaced: boolean
  formulas: AllUpSelection['formulas']
}

export const QuickbetFormula: React.ComponentClass = observeImmutable(
  quickbetState$,
  ({ record }) => {
    const { betPlaced, selection } = record.toJS()
    const formulas = isAllUpSelection(selection) ? selection.formulas : []
    return <QuickbetFormulaComponent betPlaced={betPlaced} formulas={formulas} />
  }
)

export const QuickbetFormulaComponent: React.FC<Props> = ({ betPlaced, formulas }) => {
  if (betPlaced || !formulas.length) {
    return null
  }

  return (
    <FormulaStyled>
      <Accordion title='Formula' theme={null}>
        <ul>
          {formulas.map(formula => (
            <li key={formula.formula}>
              <button
                type='button'
                data-quickbet-formula-selected={formula.isSelected}
                onClick={() => ToggleAllUpFormula(formula)}
              >
                <span>
                  {formulaNames[formula.formula as keyof typeof formulaNames] ||
                    `Pick ${formula.formula}`}
                </span>
                <span>x{formula.numberOfCombinations}</span>
              </button>
            </li>
          ))}
        </ul>
      </Accordion>
    </FormulaStyled>
  )
}

// =============
// Local Helpers
// =============

const formulaNames = {
  1: 'Singles',
  2: 'Doubles',
  3: 'Trebles',
}

// ======
// Styles
// ======

const FormulaStyled = styled.div({
  background: hexColors.whiteSmoke,

  ul: {
    borderColor: hexColors.veryLightGrey,
    borderStyle: 'solid',
    borderWidth: '1px 0 0 1px',
    display: 'flex',
    listStyle: 'none',
    margin: 0,
    padding: 0,

    li: {
      flex: '1 1 0',
      textAlign: 'center',
      borderColor: hexColors.veryLightGrey,
      borderStyle: 'solid',
      borderWidth: '0 1px 1px 0',
      flexBasis: '100%',

      button: {
        border: 'none',
        fontSize: '1.2rem',
        fontFamily: 'inherit',
        height: '5rem',
        lineHeight: 1.5,
        position: 'relative',
        width: '100%',
        textAlign: 'center',
        padding: 0,
        margin: 0,
        background: hexColors.white,
        color: hexColors.black,

        '&[data-quickbet-formula-selected="true"]': {
          background: hexColors.studio,
          color: hexColors.white,
        },

        '> span': { display: 'block' },
      },
    },
  },
})
